import { z } from "zod";

import { KiliIdFilter, KiliStringFilter } from "@/types/kili/kili-filters.type.ts";

const siteEntitySchema = z.object({
  id: z.number(),
  name: z.string(),
  businessSegment: z.string(),
  organizationName: z.string(),
  organizationId: z.number(),
  streetNumber: z.string().nullable(),
  street: z.string().nullable(),
  complement: z.string().nullable(),
  postalCode: z.string().nullable(),
  city: z.string().nullable(),
});

export type KiliSiteEntitySchema = typeof siteEntitySchema;
export type KiliSiteEntity = z.infer<typeof siteEntitySchema>;

export const kiliSitesDataTableSchema = {
  schema: siteEntitySchema,
  headers: {
    id: {
      label: "kili.datatable.site.column.site-id",
    },
    name: {
      label: "kili.datatable.site.column.name",
    },
    organizationName: {
      label: "kili.datatable.site.column.organization",
    },
    streetNumber: {
      label: "kili.datatable.site.column.street-number",
    },
    street: {
      label: "kili.datatable.site.column.street",
    },
    postalCode: {
      label: "kili.datatable.site.column.postal-code",
    },
    city: {
      label: "kili.datatable.site.column.city",
    },
  },
  filterableFields: {
    id: { filter: { filterType: KiliIdFilter }, key: "id" },
    name: { filter: { filterType: KiliStringFilter }, key: "name" },
    organizationName: { filter: { filterType: KiliStringFilter }, key: "organizationName" },
    streetNumber: { filter: { filterType: KiliStringFilter }, key: "streetNumber" },
    street: { filter: { filterType: KiliStringFilter }, key: "street" },
    postalCode: { filter: { filterType: KiliStringFilter }, key: "postalCode" },
    city: { filter: { filterType: KiliStringFilter }, key: "city" },
  },
} as const;
